module.exports = __webpack_public_path__ + "static/img/error@2x.1c02b361.png";